export const Close = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12.9644 11.7644L12.7287 12.0001L12.9644 12.2358L22.1144 21.3858C22.3217 21.5931 22.3217 21.9071 22.1144 22.1144L22.1013 22.1275L22.0898 22.1419C22.0203 22.2287 21.9051 22.2793 21.7501 22.2793C21.6292 22.2793 21.4853 22.2139 21.3858 22.1144L12.2358 12.9644L12.0001 12.7287L11.7644 12.9644L2.6144 22.1144L2.60134 22.1275L2.58981 22.1419C2.52031 22.2287 2.40509 22.2793 2.2501 22.2793C2.12915 22.2793 1.9853 22.2139 1.8858 22.1144C1.67847 21.9071 1.67847 21.5931 1.8858 21.3858L11.0358 12.2358L11.2715 12.0001L11.0358 11.7644L1.8858 2.6144C1.67847 2.40707 1.67847 2.09313 1.8858 1.8858C2.09313 1.67847 2.40707 1.67847 2.6144 1.8858L11.7644 11.0358L12.0001 11.2715L12.2358 11.0358L21.3858 1.8858C21.5931 1.67847 21.9071 1.67847 22.1144 1.8858C22.3217 2.09313 22.3217 2.40707 22.1144 2.6144L12.9644 11.7644Z"
        fill="#BA0C2F"
        stroke="#BA0C2F"
        strokeWidth="0.666667"
      />
    </svg>
  );
};
